var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenpactlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.976,
    height: 36.106,
    viewBox: "0 0 25.976 36.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175513",
    "data-name": "Group 175513",
    transform: "translate(-69 -48.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(69 48.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M64.7,107.974l12.987-9.026V89.92L64.7,98.878Z",
    transform: "translate(-51.711 -71.868)",
    fill: "#073262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M25.974,9.024l-6.551,4.543L12.989,9.1,6.545,13.575,0,9.026,12.989,0Z",
    fill: "#ff555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M6.545,58.465V49.509L0,44.96V63.012L12.989,72.04v-9.1Z",
    transform: "translate(0 -35.934)",
    fill: "#00aecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M64.7,89.89v8.964h0L71.164,94.4Z",
    transform: "translate(-51.711 -71.844)",
    fill: "#00aecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M77.687,72.065h0L71.134,67.58,64.7,72.059l6.464,4.505,6.523-4.5Z",
    transform: "translate(-51.711 -54.013)",
    fill: "#ff555f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenpactlogo);
export default __webpack_public_path__ + "static/media/genpactlogo.5c47248d1b6690832e5694081fbf3b72.svg";
export { ForwardRef as ReactComponent };